// extracted by mini-css-extract-plugin
export default {"header":"AccountForm_header__qyQGP","section_header":"AccountForm_section_header__LWE3c","eyeIcon":"AccountForm_eyeIcon__Bz-NP","action_group":"AccountForm_action_group__wp5-I"};